import gql from 'graphql-tag'
import api from './apiClient'

export default {
  // read items
  readAllByEmisor: (emisor, cursor, tipo = '02', limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readAllByEmisor($emisor: ID!, $cursor: String, $tipo: String, $limit: Int, $filter: Filter) {
            Item {
              readAllByEmisor(emisor: $emisor, cursor: $cursor, tipo: $tipo, limit: $limit, filter: $filter) {
                feed {
                  _id
                  nombre
                  codigoRapido
                  SKU
                  descripcion
                  codigoMoneda {
                    id
                    value
                    simbolo
                  }
                  tipo {
                    id
                    value
                    annotation
                  }
                  tag {
                    key
                    value
                  }
                  priceDateRange {
                    i
                    date
                    price
                  }
                  bajoDemanda
                  bajoProduccion
                  permiteInventarioNegativo
                  #img {
                  #  src
                  #}
                  #altImg {
                  #  src
                  #}
                  # FE
                  codigo
                  # codigoComercial: String no se usa en esta version, no es requerido por Hacienda.
                  clasificacion
                  unidadMedida {
                    id
                    value
                    annotation
                  }
                  unidadMedidaComercial
                  precioUnitario
                  costoUnitarioTotal
                  utilidad
                  descuento {
                    _id
                  }

                  # modoivaIncluido
                  impuesto {
                    codigo {
                      id
                    }
                    codigoTarifa {
                      id
                    }
                    tarifa
                  }

                  esCompuesto
                  precioInvertido
                  precioVenta

                  precioCompra

                  pp
                  cantidad
                  minimo
                  maximo

                  composicion {
                    _id
                    _idItem
                    nombre
                    unidadMedida
                    costoUnitario
                    porcion
                  }

                  listaCostos {
                    _id
                    _idItem
                    nombre
                    unidadMedida
                    costoUnitario
                    porcion
                  }

                  duracion
                  checkIn
                  checkOut
                  nextDay

                  attributes

                  cuentaContablePorCobrar
                  cuentaContablePorPagar

                  createdAt
                  updatedAt

                  # TODO: traer los demas campos de inventario.
                  # TODO: faltan saldos de inventario y costo
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          tipo,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Item.readAllByEmisor),

  // read stock (inventario)
  readAllStock: (emisor, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readAllByEmisor($emisor: ID!, $cursor: String, $limit: Int, $filter: FilterStock) {
            Inventario {
              readAllByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id
                  proveedor {
                    _id
                    nombre
                    #nombreComercial
                    #correoElectronico
                  }
                  documento {
                    _id
                  }
                  item {
                    _id
                    nombre
                  }
                  descripcion
                  costoUnitario
                  entrada {
                    cantidad
                    valor
                  }
                  salida {
                    cantidad
                    valor
                  }
                  saldo {
                    cantidad
                    valor
                  }
                  pp
                  peps

                  createdAt
                  updatedAt
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Inventario.readAllByEmisor),

  readMovimientosBySearchString: (emisor, searchString) =>
    api
      .send({
        query: gql`
          query readMovimientosBySearchString($emisor: ID!, $searchString: String!) {
            Inventario {
              readMovimientosBySearchString(emisor: $emisor, searchString: $searchString) {
                feed {
                  _id
                  proveedor {
                    _id
                    nombre
                  }
                  documento {
                    _id
                  }
                  item {
                    _id
                    nombre
                  }
                  descripcion
                  costoUnitario
                  entrada {
                    cantidad
                    valor
                  }
                  salida {
                    cantidad
                    valor
                  }
                  saldo {
                    cantidad
                    valor
                  }
                  pp
                  peps

                  createdAt
                  updatedAt
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          searchString
        }
      })
      .then(result => result.data.data.Inventario.readMovimientosBySearchString),

  readToBill: (emisor, tipo = '05', limit = 10, showVariants = false) =>
    api
      .send({
        query: gql`
          query readAllByEmisor($emisor: ID!, $tipo: String, $limit: Int, $showVariants: Boolean) {
            Item {
              readAllByEmisor(emisor: $emisor, tipo: $tipo, limit: $limit, showVariants: $showVariants) {
                feed {
                  _id
                  nombre
                  stockState
                  codigoRapido
                  SKU
                  descripcion
                  codigoMoneda {
                    id
                    value
                    simbolo
                  }

                  cantidad
                  bajoDemanda
                  bajoProduccion
                  permiteInventarioNegativo

                  # FE
                  codigo
                  # codigoComercial: String no se usa en esta version, no es requerido por Hacienda.
                  clasificacion
                  unidadMedida {
                    id
                    value
                    annotation
                  }
                  unidadMedidaComercial
                  precioUnitario
                  precioVenta
                  costoUnitarioTotal
                  utilidad

                  img {
                    src
                  }

                  descuento {
                    _id
                  }

                  # modoivaIncluido
                  impuesto {
                    codigo {
                      id
                    }
                    codigoTarifa {
                      id
                    }
                    tarifa
                  }

                  categoria
                  # subCategorias {
                  #   _idCategoria
                  #   nombre
                  # }

                  esCompuesto
                  precioInvertido

                  attributes
                  itemRefId

                  cuentaContablePorCobrar
                  cuentaContablePorPagar

                  showVariantAsOptions

                  preparable
                  preparableItem {
                    classificators {
                      name
                      quantityMax
                      quantityMin
                      items {
                        _id
                        nombre
                        precioExtra
                      }
                    }
                    modifiers {
                      _idAttribute
                      name
                      quantityMax
                      quantityMin
                      options {
                        name
                        factor
                        precioExtra
                      }
                    }
                    attributes {
                      _idAttribute
                      name
                      quantityMax
                      quantityMin
                      options
                    }
                  }
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          tipo,
          limit,
          showVariants
        }
      })
      .then(result => result.data.data.Item.readAllByEmisor),

  readAllItemByEmisor: emisor =>
    api
      .send({
        query: gql`
          query readAllItemByEmisor($emisor: ID!) {
            Item {
              readAllItemByEmisor(emisor: $emisor) {
                _id
                nombre

                codigoMoneda {
                  id
                  value
                  simbolo
                }

                cantidad

                clasificacion
                unidadMedida {
                  id
                  value
                  annotation
                }
                tipo {
                  id
                  value
                  annotation
                }

                precioUnitario
                costoUnitarioTotal
                utilidad
                descuento {
                  _id
                }

                # modoivaIncluido
                impuesto {
                  codigo {
                    id
                  }
                  codigoTarifa {
                    id
                  }
                  tarifa
                }

                precioCompra
                precioVenta
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Item.readAllItemByEmisor),

  create: input =>
    api
      .send({
        query: gql`
          mutation create($input: ItemInput!) {
            Item {
              create(input: $input) {
                _id
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Item.create),

  ajuste: input =>
    api
      .send({
        query: gql`
          mutation ajuste($input: InventarioInput!) {
            Inventario {
              ajuste(input: $input)
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Inventario.ajuste),

  readById: _id =>
    api
      .send({
        query: gql`
          query readById($_id: ID!) {
            Item {
              readById(_id: $_id) {
                _id
                nombre
                stockState
                codigoRapido
                SKU
                descripcion
                codigoMoneda {
                  id
                  value
                  simbolo
                }
                tipo {
                  id
                  value
                  annotation
                }
                tag {
                  key
                  value
                }
                priceDateRange {
                  i
                  date
                  price
                }
                bajoDemanda
                bajoProduccion
                permiteInventarioNegativo
                preparable
                img {
                  src
                }
                #altImg {
                #  src
                #}
                # FE
                codigo
                # codigoComercial: String no se usa en esta version, no es requerido por Hacienda.
                clasificacion
                unidadMedida {
                  id
                  value
                  annotation
                }
                unidadMedidaComercial
                precioUnitario
                costoUnitarioTotal
                utilidad
                descuento {
                  _id
                }

                # modoivaIncluido
                impuesto {
                  codigo {
                    id
                  }
                  codigoTarifa {
                    id
                  }
                  tarifa
                }

                esCompuesto
                precioInvertido
                precioVenta

                pp
                cantidad
                cantidadDescripcion
                minimo
                maximo

                composicion {
                  _id
                  _idItem
                  nombre
                  unidadMedida
                  costoUnitario
                  porcion
                }

                listaCostos {
                  _id
                  _idItem
                  nombre
                  unidadMedida
                  costoUnitario
                  porcion
                }

                duracion
                checkIn
                checkOut
                nextDay

                categoria
                # subCategorias {
                #   _idCategoria
                #   nombre
                # }

                createdAt
                updatedAt

                attributes

                cuentaContablePorCobrar
                cuentaContablePorPagar

                showVariantAsOptions
                posIndex
              }
            }
          }
        `,
        variables: { _id }
      })
      .then(result => result.data.data.Item.readById),

  readByCodigoRapido: codigoRapido =>
    api
      .send({
        query: gql`
          query readByCodigoRapido($codigoRapido: String!) {
            Item {
              readByCodigoRapido(codigoRapido: $codigoRapido) {
                _id
                nombre

                clasificacion
                # unidadMedida {
                #   id
                #   value
                #   annotation
                # }
                precioUnitario
              }
            }
          }
        `,
        variables: { codigoRapido }
      })
      .then(result => result.data.data.Item.readByCodigoRapido),

  readBySearchString: (emisor, searchString, tipo) =>
    api
      .send({
        query: gql`
          query readBySearchString($emisor: ID!, $searchString: String!, $tipo: String!) {
            Item {
              readBySearchString(emisor: $emisor, searchString: $searchString, tipo: $tipo) {
                _id
                nombre
                codigoRapido
                SKU
                descripcion
                codigoMoneda {
                  id
                  value
                  simbolo
                }
                tipo {
                  id
                  value
                  annotation
                }
                tag {
                  key
                  value
                }
                bajoDemanda
                bajoProduccion
                permiteInventarioNegativo

                # FE
                codigo
                # codigoComercial: String no se usa en esta version, no es requerido por Hacienda.
                clasificacion
                unidadMedida {
                  id
                  value
                  annotation
                }
                unidadMedidaComercial
                precioUnitario
                costoUnitarioTotal
                utilidad
                descuento {
                  _id
                }

                # modoivaIncluido
                impuesto {
                  codigo {
                    id
                  }
                  codigoTarifa {
                    id
                  }
                  tarifa
                }

                esCompuesto
                precioInvertido

                pp
                cantidad
                minimo
                maximo

                composicion {
                  _id
                  _idItem
                  nombre
                  unidadMedida
                  costoUnitario
                  porcion
                }

                listaCostos {
                  _id
                  _idItem
                  nombre
                  unidadMedida
                  costoUnitario
                  porcion
                }

                attributes

                cuentaContablePorCobrar
                cuentaContablePorPagar

                precioVenta

                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: { emisor, searchString, tipo }
      })
      .then(result => result.data.data.Item.readBySearchString),

  readItemsCompras: emisor =>
    api
      .send({
        query: gql`
          query readItemsCompras($emisor: ID!) {
            Item {
              readItemsCompras(emisor: $emisor) {
                _id
                nombre
                SKU
                codigoMoneda {
                  id
                  value
                  simbolo
                }
                codigoRapido
                codigo
                costoUnitarioTotal
                conversion
                codigoProveedor
                tipo {
                  id
                  value
                  annotation
                }
                unidadMedida {
                  id
                  value
                  annotation
                }
                impuesto {
                  tarifa
                }

                cuentaContablePorCobrar
                cuentaContablePorPagar
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Item.readItemsCompras),

  readByDateRange: (emisor, inicio, final) =>
    api
      .send({
        query: gql`
          query readByDateRange($emisor: ID!, $inicio: Date, $final: Date) {
            Inventario {
              readByDateRange(emisor: $emisor, inicio: $inicio, final: $final) {
                feed {
                  _id
                  proveedor {
                    _id
                    nombre
                    #nombreComercial
                    #correoElectronico
                  }
                  documento {
                    _id
                  }
                  item {
                    _id
                    nombre
                  }
                  descripcion
                  costoUnitario
                  entrada {
                    cantidad
                    valor
                  }
                  salida {
                    cantidad
                    valor
                  }
                  saldo {
                    cantidad
                    valor
                  }
                  pp
                  peps

                  createdAt
                  updatedAt
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          inicio,
          final
        }
      })
      .then(result => result.data.data.Inventario.readByDateRange),

  addItemCompras: input =>
    api
      .send({
        query: gql`
          mutation addItemCompras($input: ItemInput!) {
            Item {
              addItemCompras(input: $input) {
                _id
                nombre
                tipo {
                  id
                  value
                  annotation
                }
                unidadMedida {
                  id
                  value
                  annotation
                }
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Item.addItemCompras),

  delete: (_idEmisor, input) =>
    api
      .send({
        query: gql`
          mutation delete($_idEmisor: ID!, $input: [ID!]!) {
            Item {
              delete(_idEmisor: $_idEmisor, input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { _idEmisor, input }
      })
      .then(result => result.data.data.Item.delete),

  healthCheck: () =>
    api
      .send({
        query: gql`
          query healthCheck {
            healthCheck
          }
        `
      })
      .then(result => Promise.resolve(result.data.data.healthCheck)),

  itemCostoPromedio: _idItem =>
    api
      .send({
        query: gql`
          query readByItem_Id($_idItem: ID!) {
            Inventario {
              readByItem_Id(_idItem: $_idItem) {
                pp
              }
            }
          }
        `,
        variables: {
          _idItem
        }
      })
      .then(result => result.data.data.Inventario.readByItem_Id?.pp || 0),

  readVariantsByItem: _id =>
    api
      .send({
        query: gql`
          query readVariantsByItem($_id: ID!) {
            Item {
              readVariantsByItem(_id: $_id) {
                _id
                itemRefId
                precioVenta
                costoExtra
                utilidad
                emisor {
                  _id
                }
                nombre
                nombreEN
                descripcion
                descripcionEN
                descuento {
                  _id
                }
                impuesto {
                  codigo {
                    id
                  }
                  codigoTarifa {
                    id
                  }
                  tarifa
                }
                img {
                  src
                }
                pp
                cantidad
                esCompuesto
                costoUnitarioTotal
                maximo
                minimo

                composicion {
                  _id
                  _idItem
                  nombre
                  unidadMedida
                  costoUnitario
                  porcion
                }

                listaCostos {
                  _id
                  _idItem
                  nombre
                  unidadMedida
                  costoUnitario
                  porcion
                }

                # variants
                options

                precioInvertido
                precioUnitario
                utilidad
                precioVenta
                customVariantPrice
                posIndex

                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.Item.readVariantsByItem),

  readVariantsToBill: _id =>
    api
      .send({
        query: gql`
          query readVariantsByItem($_id: ID!) {
            Item {
              readVariantsByItem(_id: $_id) {
                _id
                itemRefId
                bajoDemanda
                precioUnitario
                precioVenta
                costoExtra
                utilidad
                nombre
                nombreEN
                descripcion
                descripcionEN
                esCompuesto
                descuento {
                  _id
                }
                impuesto {
                  codigo {
                    id
                  }
                  codigoTarifa {
                    id
                  }
                  tarifa
                }
                img {
                  src
                }
                cantidad
                costoUnitarioTotal
              }
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.Item.readVariantsByItem),

  saveVariant: input =>
    api
      .send({
        query: gql`
          mutation create($input: ItemInput!) {
            Item {
              create(input: $input) {
                _id
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Item.create),

  setImage: (emisor, _id, image, name) =>
    api
      .send({
        query: gql`
          mutation setImage($emisor: ID!, $_id: ID!, $image: ImageInput!, $name: String!) {
            Item {
              setImage(emisor: $emisor, _id: $_id, image: $image, name: $name)
            }
          }
        `,
        variables: {
          emisor,
          _id,
          image,
          name
        }
      })
      .then(result => result.data.data.Item.setImage),

  deleteImage: (_id, image) =>
    api
      .send({
        query: gql`
          mutation deleteImage($_id: ID!, $image: String!) {
            Item {
              deleteImage(_id: $_id, image: $image)
            }
          }
        `,
        variables: {
          _id,
          image
        }
      })
      .then(result => result.data.data.Item.deleteImage),

  updateUnidadMedida: ({ _id, _idUnidadMedida, _idEmisor }) =>
    api
      .send({
        query: gql`
          mutation updateUnidadMedida($_id: ID!, $_idUnidadMedida: ID!, $_idEmisor: ID!) {
            Item {
              updateUnidadMedida(_id: $_id, _idUnidadMedida: $_idUnidadMedida, _idEmisor: $_idEmisor)
            }
          }
        `,
        variables: {
          _id,
          _idUnidadMedida,
          _idEmisor
        }
      })
      .then(result => result.data.data.Item.updateUnidadMedida)
}
